import { termsOfUseEnTranslations } from './terms-of-use.en';
import { termsOfUseHeTranslations } from './terms-of-use.he';

export const termsOfUseTranslations = {
  en: termsOfUseEnTranslations,
  he: termsOfUseHeTranslations,
} as const;
